import { Box, Button, SubscriberStarIcon } from '@deckee/deck-hand';
import React, { FC } from 'react';
import styled from 'styled-components';

import { SheetBody } from '../../../../layouts/SheetLayout/SheetLayout';
import { HeaderBarHeading } from '../../../../layouts/components/HeaderBar/HeaderBar';

const StyledHeaderBarHeading = styled(HeaderBarHeading)`
  white-space: break-spaces;
`;

interface SubscriberWelcomeProps {
  onContinue: () => void;
}

const SubscriberWelcome: FC<SubscriberWelcomeProps> = ({ onContinue }) => (
  <SheetBody mt="4">
    <Box display="flex" flexDirection="column" alignItems="center">
      <SubscriberStarIcon width="50" height="50" />
      <StyledHeaderBarHeading pt="3" textAlign="center">
        Welcome to the DECKEE Supporters Club!
      </StyledHeaderBarHeading>

      <Box textAlign="center" mt="3">
        Thank you for supporting our mission. You can now access all of DECKEE
        including 3D Maps, unlimited logbook, VIP support and more.
      </Box>

      <Button mt="4" mb="3" wide onClick={onContinue}>
        Sounds good
      </Button>
    </Box>
  </SheetBody>
);

export default SubscriberWelcome;
